export default __webpack_public_path__ + "static/media/HexapodMain@3x.79aa3316.png";